import { useApiQuery } from '../use-api.js';

interface PolicyVersion {
  id: string;
  created_at: string;
  version: string;
  summary: string;
}

export function PolicyVersions() {
  const { data, isLoading, error } = useApiQuery<PolicyVersion[]>(
    ['policy-versions'],
    '/api/policy-versions'
  );

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Policy Versions</h2>

      {isLoading && <p className="text-sm text-gray-500">Loading…</p>}
      {error && <p className="text-sm text-red-600">Error: {String(error)}</p>}

      {data && data.length === 0 && (
        <div className="bg-white border rounded-lg p-8 text-center text-gray-400">
          <p className="text-base font-medium mb-1">No policy snapshots yet.</p>
          <p className="text-sm">Will populate when the policy snapshot ingestion task lands.</p>
        </div>
      )}

      {data && data.length > 0 && (
        <div className="relative border-l border-gray-200 ml-4">
          {data.map(v => (
            <div key={v.id} className="mb-6 ml-6">
              <span className="absolute -left-3 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-4 ring-white">
                <span className="w-2 h-2 bg-blue-600 rounded-full" />
              </span>
              <div className="bg-white border rounded-lg p-4">
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-sm font-semibold">{v.version}</span>
                  <span className="text-xs text-gray-400">
                    {new Date(v.created_at).toLocaleDateString()}
                  </span>
                </div>
                <p className="text-sm text-gray-600">{v.summary}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
